const ITEMS = ["Gate Repair", "Trailer & Hitch", "Heavy Equipment", "24/7 Emergency", "Structural Steel", "Pipe & Rail", "Steel · Aluminum · Stainless", "We Come To You"];

const Marquee = () => (
  <div data-testid="service-marquee" className="bg-coal text-cream/85 overflow-hidden py-3.5 border-y border-white/10" aria-hidden>
    <div className="flex w-max animate-marquee gap-24">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-24 whitespace-nowrap font-display font-bold uppercase tracking-[0.18em] text-sm">
          {item}
          <span className="w-2 h-2 bg-rust inline-block rotate-45" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
